import React from "react";
import PropTypes from "prop-types";
import { MapContainer, TileLayer } from "react-leaflet";

import MultiLayerProgressDonutMarker from "./MultiLayerProgressDonutMarker";
import ArcConnection from "./ArcConnection";
import AutoFitBounds from "./AutoFitBounds";

const EMPTY_SNAGS = [];

function ProjectMapView({
  locations = [],
  arcs = [],
  onLocationClick = () => {},
  onArcStatusChange = () => true,
  onLocationTeamsSave = () => ({ success: false }),
  canManageTeams = false,
  teamOptions = [],
  mapRef,
  totalScopeCount = 1,
  showSnags = false,
  onSnagClick = () => {},
  canAddSnag = false,
  onAddSnagClick = () => {},
  ...props
}) {
  return (
    <MapContainer
      center={[52.1326, 5.2913]}
      zoom={2}
      minZoom={3}
      maxZoom={20}
      zoomSnap={0.5}
      zoomDelta={0.5}
      style={{ height: "calc(85vh - 145px)", width: "100%" }}
      ref={mapRef}
      {...props}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
        maxNativeZoom={19}
        maxZoom={20}
      />
      <TileLayer
        url="https://tiles.openmaptiles.org/tiles/english/{z}/{x}/{y}.png?key=YOUR_API_KEY"
        attribution="&copy; OpenMapTiles"
        opacity={1}
        zIndex={1000}
        maxZoom={20}
      />
      {locations.map((loc) => (
        <MultiLayerProgressDonutMarker
          key={loc.locationId}
          center={[loc.latitude, loc.longitude]}
          locationId={loc.locationId}
          locationName={loc.locationName}
          scopes={loc.scope}
          assignedTeamIds={loc.teamIds}
          teamOptions={teamOptions}
          onLocationTeamsSave={onLocationTeamsSave}
          canManageTeams={canManageTeams}
          handleLocationClick={() => onLocationClick(loc)}
          qhseCount={loc.qhseCards}
          totalScopeCount={totalScopeCount}
          snags={showSnags && Array.isArray(loc.snags) ? loc.snags : EMPTY_SNAGS}
          onSnagClick={onSnagClick}
          canAddSnag={canAddSnag}
          onAddSnagClick={onAddSnagClick}
        />
      ))}
      {arcs.map((arc) => (
        <ArcConnection
          key={arc.key}
          id={arc.key}
          from={arc.from}
          to={arc.to}
          color={arc.color}
          baseColor={arc.baseColor}
          title={arc.title}
          isCompleted={arc.isCompleted}
          completeColor={arc.completeColor}
          onStatusChange={(statusPayload) =>
            onArcStatusChange({
              ...statusPayload,
              arc,
            })
          }
        />
      ))}
      <AutoFitBounds locations={locations} arcs={arcs} />
    </MapContainer>
  );
}

ProjectMapView.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object),
  arcs: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-next-line react/require-default-props
  onLocationClick: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  onArcStatusChange: PropTypes.func,
  onLocationTeamsSave: PropTypes.func,
  canManageTeams: PropTypes.bool,
  teamOptions: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  mapRef: PropTypes.object,
  totalScopeCount: PropTypes.number,
  showSnags: PropTypes.bool,
  onSnagClick: PropTypes.func,
  canAddSnag: PropTypes.bool,
  onAddSnagClick: PropTypes.func,
};

ProjectMapView.defaultProps = {
  locations: [],
  arcs: [],
  onLocationClick: () => {},
  onArcStatusChange: () => true,
  onLocationTeamsSave: () => ({ success: false }),
  canManageTeams: false,
  teamOptions: [],
  totalScopeCount: 1,
  showSnags: false,
  onSnagClick: () => {},
  canAddSnag: false,
  onAddSnagClick: () => {},
};

export default ProjectMapView;
